import MUIStack, { StackProps as MuiStackProps } from '@mui/material/Stack';

export interface StackProps extends MuiStackProps {}

export const Stack = MUIStack;
